import { useDispatch as reduxUseDispatch } from 'react-redux';
import { Action, AnyAction, Dispatch } from 'redux';

const useDispatch = <A extends Action = AnyAction>(): Dispatch<A> => {
  return reduxUseDispatch();
};

export default useDispatch;
